import { useQuery } from '@apollo/client';
import { GET_MAINTENANCE_DATA } from '@api/queries/maintenanceData';
import type { GetMaintenanceInfoQuery, MaintenanceData } from '@gql/graphql';

export default function useMaintenanceData(): MaintenanceData | undefined {
    const { data } = useQuery<GetMaintenanceInfoQuery>(GET_MAINTENANCE_DATA);
    return data?.maintenanceData;
}
